import { apiRequest } from "./api";
import { getSessionId, getDeviceType } from "./analytics";

/* One entry in the search history per search the customer actually made.
 *
 * Called from the lists, not the search bar, because only the list knows what the
 * search found - and "found nothing" is the most useful thing the history records.
 * Each call replaces the one before it on the same page, and the entry is sent only
 * once the words have stood still for SETTLE_MS: typing "gollapudi" is one search,
 * not nine. The same words twice in a row are sent once.
 *
 * The server identifies a signed-in searcher from their token; nothing here says who
 * the user is. */

const SETTLE_MS = 1500;
const timers = {};
const lastSent = {};

export function cancelSearchLog(page) {
  clearTimeout(timers[page]);
}

export function logSearch(page, { query, results, mode = "TEXT", place = null } = {}) {
  clearTimeout(timers[page]);
  const q = String(query || "").trim().replace(/\s+/g, " ");
  if (q.length < 2) { lastSent[page] = ""; return; }

  timers[page] = setTimeout(() => {
    // A filter changing the count of the same words is not a new search.
    const key = `${q.toLowerCase()}|${mode}|${place || ""}`;
    if (lastSent[page] === key) return;
    lastSent[page] = key;
    apiRequest("/analytics/search", {
      method: "POST",
      body: JSON.stringify({
        query: q.slice(0, 100),
        page,
        results: Number.isInteger(results) ? results : null,
        mode,
        place,
        city: localStorage.getItem("sramika_selected_city") || "",
        sessionId: getSessionId(),
        deviceType: getDeviceType(),
      }),
    }).catch(() => {}); // the history is never worth an error on the customer's screen
  }, SETTLE_MS);
}
